import { render, staticRenderFns } from "./CategoryListTable.vue?vue&type=template&id=1c696a8c"
import script from "./CategoryListTable.vue?vue&type=script&lang=js"
export * from "./CategoryListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports